// Function to calculate BASE_URL
const calculateBaseUrl = () => {
  const { hostname } = window.location; // Get the current hostname

  if (hostname === "localhost") {
    return " https://tenants.betaadmin.com";
  } else {
    const parts = hostname.split("."); // Split the domain into parts
    if (parts.length === 3) {
      parts[0] = "tenants"; // Replace 'xxx' with 'api'
      return `https://${parts.join(".")}`; // Rejoin parts to form the new domain
    }
    return ""; // Fallback, in case the domain doesn't match expected patterns
  }
};

//----------------------------------------------

export const BASE_URL = calculateBaseUrl();

export const TENANTS_ENDPOINTS = {
  REGISTER_TENANT: "/register",
};
